import { useQuery, useQueryClient } from '@tanstack/react-query';
import { EncabezadoPagina } from '@xiltrion/ui/bloques/encabezado-pagina';
import { EstadoVacio } from '@xiltrion/ui/bloques/estados';
import { Badge } from '@xiltrion/ui/badge';
import { Button } from '@xiltrion/ui/button';
import { Icono } from '@xiltrion/ui/icono';
import { Item, ItemContent, ItemDescription, ItemTitle } from '@xiltrion/ui/item';
import { formatDistanceToNow } from 'date-fns';
import { es } from 'date-fns/locale';
import { apiGet, apiPost } from '@/api/client';
import type { NotificationRow } from '@/api/types';

export function NotificationsPage() {
  const qc = useQueryClient();
  const { data = [] } = useQuery({ queryKey: ['notifications', 'all'], queryFn: () => apiGet<NotificationRow[]>('/me/notifications', { limit: 200 }) });
  const read = (ids: string[] | 'all') => void apiPost('/me/notifications/read', { ids }).then(() => qc.invalidateQueries({ queryKey: ['notifications'] }));
  return (
    <div className="mx-auto max-w-6xl space-y-6 p-6">
      <EncabezadoPagina titulo="Avisos" descripcion="Lo que te mandan todas las apps de la suite." acciones={data.some((n) => !n.readAt) ? <Button variant="outline" onClick={() => read('all')}><Icono nombre="mdi:check-all" />Marcar todos leídos</Button> : undefined} />
      {!data.length ? <EstadoVacio titulo="Sin avisos" descripcion="Cuando una app te avise algo, aparecerá aquí." /> : (
        <div className="space-y-1">
          {data.map((n) => (
            <Item key={n.id} variant={n.readAt ? 'default' : 'muted'} asChild>
              <a href={n.link ?? '#'} onClick={() => { if (!n.readAt) read([n.id]); }}>
                <Icono nombre={n.appIcon as never} className="size-5 text-muted-foreground" />
                <ItemContent><ItemTitle>{n.title}{!n.readAt && <Badge size="sm" variant="primary-light" className="ml-2">nuevo</Badge>}</ItemTitle><ItemDescription>{n.appName} · {formatDistanceToNow(new Date(n.createdAt), { addSuffix: true, locale: es })}{n.body ? ` · ${n.body}` : ''}</ItemDescription></ItemContent>
                {n.link && <Icono nombre="mdi:open-in-new" className="text-muted-foreground" />}
              </a>
            </Item>
          ))}
        </div>
      )}
    </div>
  );
}
